/**
 * @fileoverview Position strategy interface for theme positioning logic.
 */

import { MatchingPair, ShapePositions } from "../../utilities/GameUtils";
import { BaseTheme } from "../abstract/BaseTheme";

/**
 * Strategy interface for calculating shape positions.
 * Different themes can use different positioning strategies (vertical, grid, etc.).
 */
export abstract class PositionStrategy {
    /**
     * Calculate positions for draggable and target shapes.
     * @returns Positions for DS and TS
     */
    abstract calculatePositions(width: number, height: number, matchingPairs: MatchingPair[], shapeSize: number, isSequential: boolean): ShapePositions;

    // default is true
    isThemeValid(_theme: BaseTheme): boolean {
        return true;
    }

    // default size
    abstract getShapeSize(height: number, width: number, numPairs: number): number ;
}
